import React from 'react';
import { notification, Modal, Button, Input, Icon, Filelist } from '@ss/mtd-react';
import { Form, Upload } from '@block/plug';
import tipImg from '../../../imgs/feedback.png';
import { doAction } from '../../utils';
import Url from './url';

const { helper } = Upload;

interface Props {
  fileType?: string;
}

interface State {
  visible: boolean;
  email: any;
  list: any[];
}
class Feedback extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      visible: false,
      email: null,
      list: [],
    };
  }

  formRef: React.RefObject<any>;

  async componentDidMount() {
    const data = await doAction(Url.getPersonalInfo, {}, null);
    let email = '个人邮箱';
    if (data) {
      email = data.email;
    } else {
      notification.error({
        title: '无法获取个人邮箱，可能导致问题解答发送失败！',
      });
    }
    this.setState({ email });
  }

  // 问题反馈按钮点击事件
  handleFeedback = async () => {
    const ref = this.formRef.current;
    const { list } = this.state;
    if (ref?.validateFields()) {
      const { message } = ref.getFieldsValueIncludeHide();
      const res = await doAction(
        Url.feedback,
        {
          message,
          files: list,
        },
        { hideSucToaster: true },
      );
      notification.success({
        title: res.message,
      });
      this.handleClose();
    }
  };

  handleChangeVisible = () => {
    this.setState({ visible: true });
  };

  handleValidateFileType = (file, accepted) => {
    const fileExt = (/^.*\.(.*)$/.exec(file.name) || ['', ''])[1].toLowerCase();
    const valid = accepted.includes(fileExt);
    if (!valid) {
      notification.error({
        message: `不支持上传非 ${accepted.join('、')}格式文件，请重新上传`,
      });
    }
    return valid;
  };

  handleValidateFileSize = (file, size) => {
    const valid = file.size / 1024 <= size * 1024;
    if (!valid) {
      notification.error({
        message: `文件大小超过${size}M,请重新上传`,
      });
    }
    return valid;
  };

  handleUpload = (file) => {
    const { fileType } = this.props;

    const type = fileType || ['png', 'jpeg', 'jpg', 'bmp'];
    if (!this.handleValidateFileType(file, type) || !this.handleValidateFileSize(file, 10)) {
      return false;
    }

    helper.upload(Url.uploadAttachment, file, {
      params: {},
      onSuccess: (res) => {
        const { list } = this.state;
        list.push(res);
        this.setState({ list });
      },
      onError: (err) => {
        notification.error({
          message: err.message || '上传失败',
        });
      },
    });
    return null;
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  handleRemove = async (fileId) => {
    await doAction(Url.deleteAttachment, {
      fileId,
    });
    const { list } = this.state;
    this.setState({ list: list.filter((item) => item.fileId !== fileId) });
  };

  render() {
    const { visible, list, email } = this.state;
    return (
      <div className="feedback">
        <img src={tipImg} alt="" onClick={this.handleChangeVisible} />
        {visible ? (
          <Modal title="问题反馈" maskClosable={false} style={{ width: '450px' }} onClose={this.handleClose}>
            <Modal.Body>
              <Form ref={this.formRef} labelWidth="120px">
                <Form.Item formItemKey="message" labelPosition="top" labelWidth={0} required message="不能为空">
                  <Input.TextArea
                    toFormItem
                    placeholder="告诉我们您遇到的问题或建议"
                    autosize={{ minRows: 8 }}
                    maxLength={500}
                  />
                </Form.Item>
                <Form.Item formItemKey="files" span={0} labelWidth={0}>
                  <Filelist type="picture" style={{ width: 300, marginTop: '10px' }}>
                    {list.map((item) => (
                      <Filelist.Item
                        key={item.url}
                        name={item.name}
                        url={item.url}
                        onRemove={() => this.handleRemove(item.fileId)}
                      />
                    ))}
                    <Upload className="feedback__content" multiple onUpload={this.handleUpload}>
                      <div className="feedback__wrapper">
                        <Icon className="feedback__icon" type="add" />
                        <div className="feedback__text">请上传文件</div>
                        <div className="feedback__text">(小于10M)</div>
                      </div>
                    </Upload>
                  </Filelist>
                </Form.Item>
              </Form>
              <div>
                问题解答将反馈至：
                {email} 请注意查收
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button type="primary" onClick={this.handleFeedback}>
                提交反馈
              </Button>
            </Modal.Footer>
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default Feedback;
